import { useState } from 'react';
import PhotoUploader from './PhotoUploader.jsx';

// photo_and_text challenges expect a photo + a short caption. Phase 3
// composes the existing PhotoUploader with a caption textarea; the
// caption rides along on the verifier call as part of the submission's
// "claimed" metadata. Caption-rubric scoring lands Phase 4 polish.

export default function PhotoAndTextSubmission({ tripId, playerId, challengeId, testMode, onVerified }) {
  const [caption, setCaption] = useState('');
  return (
    <div className="space-y-3">
      <textarea
        value={caption}
        onChange={(e) => setCaption(e.target.value)}
        rows={3}
        placeholder="Caption / verdict / explanation…"
        className="w-full resize-y rounded-md border border-border-tertiary bg-bg-primary px-3 py-2 font-serif text-base text-fg-primary placeholder:text-fg-tertiary focus:border-action focus:outline-none"
      />
      <PhotoUploader
        tripId={tripId}
        playerId={playerId}
        challengeId={challengeId}
        testMode={testMode}
        caption={caption}
        onVerified={onVerified}
      />
    </div>
  );
}
